var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 220,
    viewBox: "0 0 212 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_437_1911)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.192,
    y: 113.109,
    width: 66.0317,
    height: 66.0317,
    rx: 33.0159,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.715 129.617L156.556 147.776M174.715 129.617L163.16 162.633L156.556 147.776M174.715 129.617L141.699 141.173L156.556 147.776",
    stroke: "#F8A792",
    strokeWidth: 3.9619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.318 82.1385V86.6947C155.312 97.3742 151.854 107.766 145.46 116.319C139.065 124.873 130.077 131.13 119.836 134.158C109.595 137.186 98.6493 136.822 88.6317 133.121C78.6141 129.42 70.0612 122.58 64.2486 113.621C58.436 104.662 55.6752 94.0642 56.3779 83.4079C57.0805 72.7516 61.2091 62.608 68.1477 54.4898C75.0864 46.3716 84.4634 40.7138 94.8802 38.3602C105.297 36.0067 116.196 37.0835 125.951 41.43M155.318 47.0757L105.794 96.649L90.9372 81.7919",
    stroke: "#EC4E22",
    strokeWidth: 9.90476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_437_1911)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.7754,
    y: 0.857422,
    width: 66.0317,
    height: 66.0317,
    rx: 33.0159,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_1911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5344 36.9936L45.5369 52.0323L53.7909 47.0799L62.0449 52.0323L60.0474 36.9771M65.3465 27.2704C65.3465 33.6524 60.1729 38.826 53.7909 38.826C47.409 38.826 42.2354 33.6524 42.2354 27.2704C42.2354 20.8884 47.409 15.7148 53.7909 15.7148C60.1729 15.7148 65.3465 20.8884 65.3465 27.2704Z",
    stroke: "#F8A792",
    strokeWidth: 3.30159,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_437_1911",
    x: 105.383,
    y: 113.109,
    width: 105.651,
    height: 125.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 9.90476,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.90476
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95238
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 19.8095,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 39.619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.8095
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_437_1911",
    result: "effect2_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_437_1911",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_437_1911",
    x: 0.965866,
    y: 0.857422,
    width: 105.651,
    height: 125.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 9.90476,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.90476
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95238
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 19.8095,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 39.619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.8095
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_437_1911",
    result: "effect2_dropShadow_437_1911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_437_1911",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_1911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.619,
    height: 39.619,
    fill: "white",
    transform: "translate(33.9814 14.0645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishIcon);
export default __webpack_public_path__ + "static/media/finish_icon.ab0bcd5e3f027a5aa8e1beb6f1697f66.svg";
export { ForwardRef as ReactComponent };